import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title as NgTitle } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MetaTitleService {
  constructor(private router: Router, private titleService: NgTitle) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.updateTitle());
  }

  private updateTitle(): void {
    const route = this.router.routerState.root;
    let title = this.getTitleFromRoute(route);
    if (title) {
      this.titleService.setTitle(title + ' - Oktopus');
    } else {
      console.warn('This page is missing a title : ' + this.router.routerState.snapshot.url);
    }
  }

  private getTitleFromRoute(route: ActivatedRoute): string | null {
    let child = route.firstChild;
    while (child) {
      if (child.component) {
        const title = Reflect.getMetadata('title', child.component);
        if (title) return title;
      }
      child = child.firstChild;
    }
    return null;
  }
}
